
                export default function (Component) {
                    Component.__source = "library/components/VabLanguage/index.vue"
                }
            